import { Events } from "./Events";
import { Header } from "./Header";
import { ListBase, useRecordContext } from "react-admin";
import { MissionRecord } from "../types";
import { Timeline } from "./Timeline";
import { useShowMissionEventActions } from "./functions";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";

export const Dashboard = () => {
	const mission = useRecordContext<MissionRecord>();

	const showMissionEventActions = useShowMissionEventActions(mission);

	if (!mission) return null;

	return (
		<Grid container spacing={2} padding={{ xs: 1, mobile: 2 }}>
			<Grid item xs={12}>
				<Header />
			</Grid>
			<Grid item xs={12}>
				<Divider />
			</Grid>
			<ListBase
				resource="mission-events"
				perPage={1000} // assuming mission will never have more than 1000 events
				filter={{ mission_id: mission.id }}
			>
				{showMissionEventActions && (
					<Grid item xs={12}>
						<Events />
					</Grid>
				)}
				<Grid item xs={12}>
					<Timeline />
				</Grid>
			</ListBase>
		</Grid>
	);
};
